"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Tooltips = _ref => {
  let {
    prefix,
    values,
    range,
    className,
    format = val => val,
    rtl
  } = _ref;
  return _react.default.createElement("div", {
    className: className
  }, values.length > 1 ? _react.default.createElement(RangeTooltip, {
    prefix: prefix,
    values: values,
    range: range,
    format: format,
    rtl: rtl
  }) : _react.default.createElement(Tooltip, {
    prefix: prefix,
    value: values[0],
    range: range,
    format: format,
    rtl: rtl
  }));
};

const normalizeValue = (value, _ref2) => {
  let {
    min,
    max
  } = _ref2;
  return 100 * (value - min) / (max - min);
};

const Tooltip = _ref3 => {
  let {
    prefix,
    value,
    range,
    format = val => val,
    rtl
  } = _ref3;

  const divRef = _react.default.useRef();

  const [halfWidth, setHalfWidth] = _react.default.useState('0px');

  if (typeof window !== 'undefined') {
    _react.default.useLayoutEffect(() => {
      const _halfWidth = `${((divRef.current ? divRef.current.getBoundingClientRect().width - 24 : 0) * 0.5).toFixed(1)}px`;
      setHalfWidth(_halfWidth);
    }, [format(value), range]);
  }

  const toolTipPosition = `${normalizeValue(value, range)}%`;
  const rightBound = `min(${toolTipPosition}, 100% - ${halfWidth})`;
  const leftRightBound = `max(${rightBound}, ${halfWidth})`;
  return _react.default.createElement("div", {
    ref: divRef,
    className: `${prefix}slider-tooltip`,
    style: {
      [rtl ? 'right' : 'left']: leftRightBound
    }
  }, `${format(value)}`);
};

const RangeTooltip = _ref4 => {
  let {
    prefix,
    values: [left, right],
    range,
    format = val => val,
    rtl
  } = _ref4;
  return _react.default.createElement(Tooltip, {
    prefix: prefix,
    value: (right + left) * 0.5,
    range: range,
    format: () => `${format(left)} – ${format(right)}`,
    rtl: rtl
  });
};

var _default = Tooltips;
exports.default = _default;